import React from 'react'
import { RelatedTransaction } from '@finance-lab/utils/types'
import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'
import { Link } from 'react-router-dom'
import { TransactionTypeShort } from 'types/TransactionType'
import { getUrlForType } from '../../utils/getUrlForEntity'
import { formatDateYYYYMMDD } from '../../packages/utils/numberFormatters'
import { getIssueDate } from '../../utils/issues/getIssueDate'

const getDateForTransaction = (transaction: RelatedTransaction) => {
    switch (transaction.entityType) {
        case 'Issue':
            return getIssueDate(transaction)
        case 'Convertible':
            return transaction.maturityDate
        case 'Warrant':
            return transaction.subEndDate
    }
}

export const PressReleaseRelatedTransactions = ({
    relatedTransactions,
}: {
    relatedTransactions: RelatedTransaction[]
}) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
            {relatedTransactions
                .map((t) => ({ ...t, url: getUrlForType(t) }))
                .map((t) => (
                    <>
                        <Chip
                            key={t.id}
                            label={
                                <Box sx={{ whiteSpace: 'nowrap', display: 'flex', gap: 1.5 }}>
                                    <div>
                                        {t.entityType === 'Convertible' && t.name}
                                        {t.entityType !== 'Convertible' &&
                                            TransactionTypeShort[t.entityType === 'Issue' ? t.issueType : t.entityType]}
                                    </div>
                                    <Box>{formatDateYYYYMMDD(getDateForTransaction(t))}</Box>
                                </Box>
                            }
                            component={Link}
                            clickable
                            color={
                                TransactionTypeShort[t.entityType === 'Issue' ? t.issueType : t.entityType] ?? 'black'
                            }
                            variant='filled'
                            to={t.url as string}
                            size='small'
                            sx={{
                                ':visited': {
                                    color: `${TransactionTypeShort[t.entityType === 'Issue' ? t.issueType : t.entityType]}.contrastText`,
                                },
                                ':hover': {
                                    color: `#fff`,
                                    backgroundColor: `${TransactionTypeShort[t.entityType === 'Issue' ? t.issueType : t.entityType]}.dark`,
                                    textDecoration: 'none',
                                },
                            }}
                        />
                    </>
                ))}
        </Box>
    )
}
